<template>
  <div class="modal cart-modal">
    <div 
      class="overlay overlay-invisible" 
      @click="$parent.closeCart"
    />
    <div class="wrapper">
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="form-fields-wrapper">
                <div class="cart-up">
                  <div class="cart-top">
                    <div class="desc desc-main">
                      <b>{{ $t('Cart') }}</b>
                    </div>
                    <img 
                      class="close" 
                      src="./../images/close.svg"
                      @click="$parent.closeCart" 
                    >
                    <a 
                      v-if="$parent.cartContents && $parent.cartContents.length"
                      class="desc desc-clear"
                      @click="$parent.clearCart"
                    >
                      {{ $t('Clear cart') }}
                    </a>
                  </div>
                  <div class="product-list">
                    <div 
                      v-if="$parent.cartContents && !$parent.cartContents.length"
                      class="desc desc-empty"
                    >
                      {{ $t('Cart is empty') }}
                    </div>
                    <div 
                      v-for="(item, i) in $parent.cartContents" 
                      :key="i"
                      class="item"
                    >
                      <div class="preview">
                        <img 
                          :src="$parent.imgDomain + item.item.img_url" 
                          class="img"
                        >
                      </div>
                      <div class="desc">
                        <b>{{ item.item.title }}</b>
                      </div>
                      <div class="price desc">
                        <b>
                          <span class="currency">
                            {{ $parent.currency }}
                          </span>
                          {{ item.item.price }} 
                        </b>
                      </div>
                      <div 
                        class="delete" 
                        @click="$parent.removeFromCart(item.item, item.item_id)"
                      >
                        <img 
                          src="./../images/remove.svg"
                          class="img"
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="cart-bottom">
                  <div class="desc">
                    <span>{{ $t('Total') }}</span>
                    <span>{{ $parent.currency }} {{ $parent.totalSum }}</span>
                  </div>
                  <button 
                    class="button"
                    @click="buy" 
                  >
                    {{ $t('Buy') }}
                  </button>
                </div>
                <transition name="slide">
                  <div 
                    v-if="$parent.error" 
                    class="error-desc desc red"
                  >
                    {{ $parent.error }}
                  </div>
                </transition>
                <transition name="slide">
                  <div 
                    v-if="successMessage" 
                    class="desc green"
                  >
                    {{ successMessage }}
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Cart',
  props: [],
  data: function() {
    return {
      successMessage: '',
      balance: ''
    }
  },
  mounted() {
    this.getBalance();
  },
  methods: {
    getBalance() {
      this.$http.get(process.env.VUE_APP_API + 'user/profile')
      .then((res) => {
          this.balance = res.data.balance;
      })
      .catch(() => {
      })
    },
    buy() {
      this.$http.post(process.env.VUE_APP_API + 'purchase/product')
      .then((res) => {
        let self = this;
        if (res.data.status == "OK") {
          this.$emit('setError', '');
          this.successMessage = 'Success';
          setTimeout(function() {
            self.$parent.closeCart();
            self.$parent.getDepositHistory();
            self.$parent.getOrderHistory();
            self.$parent.getCartContents();
            self.$parent.getProfile();
            self.$parent.openProfileModal();
          }, 1500)
          
        } else {
          this.$emit('setError', res.data.message)
        }
      })
      .catch((res) => {
        this.$emit('setError', res.response.data.message)
      })
    }
  }
}
</script>